const newsletterSection = document?.querySelector(".newsletter-section");
const newsletterFormSubmit = newsletterSection?.querySelector(".btn");
const newsletterModalSection = document?.querySelector(".newsletter-modal");
const newsletterModalFormSubmit = newsletterModalSection?.querySelector(".btn");
const newsletterModalWrapper = newsletterModalSection?.querySelector(
  ".newsletter-modal-wrapper"
);
const newsletterModalClose =
  newsletterModalSection?.querySelector(".close-modal");
const modalDelay = (+newsletterModalSection?.dataset?.delay || 0) * 1000;
const modalDays = +newsletterModalSection?.dataset?.showafter;

const getCookieData = (name) => {
  const value = `; ${document?.cookie}`;
  const parts = value?.split(`; ${name}=`);
  if (parts?.length === 2) return parts?.pop()?.split(";")?.shift();
};

const setCookieData = (name, value, days) => {
  const date = new Date();
  date.setTime(date?.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = "expires=" + date?.toUTCString();
  document.cookie = `${name}=${value}; ${expires}; path=/`;
};

const showModalAgain = getCookieData("show_modal_again");
const newsletterModalCookie = getCookieData("newsletter_modal");

if (newsletterModalSection) {
  if (!newsletterModalCookie) {
    if (!showModalAgain) {
      setTimeout(() => {
        newsletterModalSection?.classList?.add("active");
      }, modalDelay);
    }
  }
}

const handleNewsletterSubmit = async (e, section) => {
  let html = "";
  const newsletterInputWrapper = section?.querySelector(".input-wrapper");
  try {
    const newsletterInput = section?.querySelector("input");
    const inputValue = newsletterInput?.value;
    const inputError = newsletterInputWrapper?.querySelector(".error");
    const success = newsletterInputWrapper?.querySelector(".success");
    const newsletterFormSubmit = e?.target;
    newsletterFormSubmit?.classList?.add("loading");

    const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    if (inputError) {
      inputError?.remove();
    }
    if (success) {
      success?.remove();
    }

    if (!inputValue) {
      html = "<p class='error'>This field is required</p>";
      newsletterInputWrapper.insertAdjacentHTML("beforeend", html);
      newsletterFormSubmit?.classList?.remove("loading");
      return;
    }

    if (!regex.test(inputValue)) {
      html = "<p class='error'>This email is invalid</p>";
      newsletterInputWrapper.insertAdjacentHTML("beforeend", html);
      newsletterFormSubmit?.classList?.remove("loading");
      return;
    }

    const formdata = new FormData();
    formdata.append("g", "V3JbxX");
    formdata.append("email", inputValue);

    const requestOptions = {
      method: "POST",
      body: formdata,
    };

    const result = await fetch(
      "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
      requestOptions
    );
    const submitResult = await result?.json();

    if (submitResult?.success) {
      html =
        "<p class='success'>You've successfully subscribed to our newsletter.</p>";
      const date = new Date();
      date.setFullYear(date.getFullYear() + 10);
      const expires = date?.toUTCString();
      document.cookie = `newsletter_modal=true; path=/; expires=${expires}`;
      newsletterInputWrapper.insertAdjacentHTML("beforeend", html);
      newsletterFormSubmit?.classList?.remove("loading");
      setTimeout(() => {
        newsletterModalSection.style.display = "none";
      }, 500);
    } else {
      html = `<p class='error'>${
        submitResult?.errors?.[0] || "Form submission failed"
      }</p>`;
      newsletterInputWrapper.insertAdjacentHTML("beforeend", html);
      newsletterFormSubmit?.classList?.remove("loading");
    }
  } catch (e) {
    html = `<p class='error'>Form submission failed</p>`;
    newsletterInputWrapper.insertAdjacentHTML("beforeend", html);
    newsletterFormSubmit?.classList?.remove("loading");
    console.log(e);
  }
};

newsletterFormSubmit?.addEventListener("click", async function (e) {
  handleNewsletterSubmit(e, newsletterSection);
});

newsletterModalFormSubmit?.addEventListener("click", async function (e) {
  handleNewsletterSubmit(e, newsletterModalSection);
});

newsletterModalClose?.addEventListener("click", function () {
  newsletterModalSection.style.display = "none";
  if (modalDays > 0) {
    setCookieData("show_modal_again", true, modalDays);
  }
});
newsletterModalWrapper?.addEventListener("click", function (e) {
  e?.stopPropagation();
});

newsletterModalSection?.addEventListener("click", function () {
  newsletterModalSection.style.display = "none";
  if (modalDays > 0) {
    setCookieData("show_modal_again", true, modalDays);
  }
});
